import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconPerson from "@material-ui/icons/PersonOutline";
import IconPlus from "@material-ui/icons/Add";
import IconMinus from "@material-ui/icons/Remove";
import IconDown from "@material-ui/icons/ArrowDownward";
import IconUp from "@material-ui/icons/ArrowUpward";
import {Close,ArrowDropUp,ArrowDropDown} from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
 

  label: {
    padding: "5px 5px 0px 5px",
    fontSize: 12,
    lineHeight: 1.1,
    color:'var(--darker)'
  },
  smallText: { fontSize: "12px !important", padding: "0px 5px 0px 5px" ,    color:'var(--darker)'},

  buttonMinus: {
    backgroundColor: 'var(--lighttextcolor)',
    color:'var(--darker)',

    padding: "5px",
  },
  buttonPlus: {
    backgroundColor: 'var(--lighttextcolor)',
    color:'var(--darker)',
    padding: "5px",
  },
  passengerCount: {
    padding: "5px 12px",
  },
  flexRow:{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  }
}));

let tempData={}
let isTempSet=false;
export default function PassengerCard(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  let [adults,setAdults]=React.useState(1);
  let [childrens,setChildrens]=React.useState(0);

  React.useEffect(()=>{
    setAdults(props.adults);
    setChildrens(props.childrens);
  },[props.adults,props.childrens])


  const handleChange=(adults,childrens)=>
  {
    if(props.onChange)
    {
      props.onChange({adults,childrens})
    }
  }



  const update=(key,op)=>
  {
      // let {adults,childrens,infants}=props;  

      
      switch(op)
      {
          case '+':
            
            switch(key)
            {
                case 'adults':         
                      if(adults<10)adults=adults+1;
                      break;
                case 'childrens':         
                      if(childrens<10)childrens=childrens+1;
                      break;
            }
            break;
          case '-':
            switch(key)
            {
                case 'adults':         
                      if(adults>0)
                      adults=adults-1;
                      break;
                case 'childrens':         
                      if(childrens>0)childrens=childrens-1;
                      break;
            }
              break;

      }
      setAdults(adults);
      setChildrens(childrens);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {

    setAnchorEl(null);
  };
  const handleCancel = () => {
    setAdults(props.adults);
    setChildrens(props.childrens);
    setAnchorEl(null);
  };
  
  const handleSubmit = () => {
    handleChange(adults,childrens)
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <div className='action-button hotel-guest-box' onClick={handleClick}>
        <IconPerson style={{ fontSize: 22 }} /> 
        <Typography component="span" > {props.adults+props.childrens}</Typography>
        <Typography variant="span" style={{marginLeft:10}}>
            {open?<ArrowDropUp/>:<ArrowDropDown/>}
        </Typography>     </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {" "}
        <div style={{ padding: 20 ,backgroundColor:'var(--backgroundcolor)',borderRadius:'5px',minWidth:'250px'}}>
          <div className="row" style={{ padding: 10 }}>
            <div className="col-sm-6 col-md-6">
              <Typography className={classes.label}>Adults</Typography>
              <Typography className={classes.smallText}>Adults</Typography>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className={classes.flexRow} >
                <a className="btnMinus" onClick={()=>update('adults','-')}>
                  <IconMinus />
                </a>
                <Typography className={classes.passengerCount}  style={{color:'var(--darker)'}}> {adults}</Typography>
                <a className="btnPlus" onClick={()=>update('adults','+')}>
                  <IconPlus />
                </a>
              </div>
            </div>
          </div>

          <div className="row" style={{ padding: 10 }}>
            <div className="col-sm-6 col-md-6">
              <Typography className={classes.label}>Childrens</Typography>
              <Typography className={classes.smallText}>Aged 2-11</Typography>
            </div>
            <div className="col-sm-6 col-md-6">
            <div className={classes.flexRow} >
                <a className="btnMinus" onClick={()=>update('childrens','-')}>
                  <IconMinus />
                </a>
                <Typography className={classes.passengerCount} style={{color:'var(--darker)'}}> {childrens}</Typography>
                <a className="btnPlus" onClick={()=>update('childrens','+')}>
                  <IconPlus />
                </a>
              </div>
            </div>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <div className="col-sm-6 col-md-6 ">
              <div  className="cancel-button" onClick={handleCancel}>
                Cancel
              </div>
            </div>
            <div className="col-sm-6 col-md-6 ">
              <div  className="success-button" onClick={handleSubmit}>
                Done
              </div>
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );
}
PassengerCard.defaultProps={
  adults:1,
  childrens:0,
  infants:0
}